var exports = {
  "W": "CardBase__ydczeX",
};

module.exports = exports;
